import { render, staticRenderFns } from "./store-admin-add.vue?vue&type=template&id=7fdf0937&scoped=true&"
import script from "./store-admin-add.vue?vue&type=script&lang=js&"
export * from "./store-admin-add.vue?vue&type=script&lang=js&"
import style0 from "./store-admin-add.vue?vue&type=style&index=0&id=7fdf0937&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdf0937",
  null
  
)

export default component.exports